import { css } from 'styled-components';
import { GetColor } from 'venn-ui-kit';

export const RangeCellClass = 'range-cell';

export const BoldRowGroupCellClass = 'ag-bold-group-row';
export const AllocationCellClass = 'allocation-cell';
export const AllocationTotalCellClass = 'allocation-total-cell';
export const AllocationHeaderCellClass = 'allocation-header-cell';
export const AllocationHeaderGroupCellClass = 'allocation-header-group-cell';
export const TaxInfoHeaderGroupCellClass = 'tax-info-header-group-cell';
export const TaxInfoHeaderCellClass = 'tax-info-header-cell';
export const TaxInfoHeaderFirstCellClass = 'tax-info-header-first-cell';
export const TaxInfoHeaderRightAlignedCellClass = 'tax-info-header-right-aligned-cell';
export const TaxInfoCellLeftAlignedClass = 'tax-info-cell-left-aligned';

export const AxisRowClass = 'axis-cell';
export const DisabledCellClass = 'disabled-cell';

export const columnStyles = css`
  .${AllocationHeaderCellClass} {
    text-align: right;
    border-right: 1px solid ${GetColor.GreyScale.Grey30} !important;
    background-color: ${GetColor.GreyScale.Grey20};
    :hover {
      background-color: ${GetColor.GreyScale.Grey20} !important;
    }

    .ag-header-cell-label {
      justify-content: flex-end;
    }
  }

  .${BoldRowGroupCellClass} {
    font-weight: bold;
  }

  .${AllocationCellClass} {
    text-align: right;
  }

  .${AllocationTotalCellClass} {
    background-color: ${GetColor.GreyScale.Grey20};
  }

  .${TaxInfoHeaderGroupCellClass} {
    padding: 0 8px !important;
    background-color: ${GetColor.GreyScale.Grey10} !important;
    font-weight: normal;
    border-top: 1px solid ${GetColor.GreyScale.Grey30};
    border-right: 1px solid ${GetColor.GreyScale.Grey30};
    border-left: 1px solid ${GetColor.GreyScale.Grey30};
  }

  .${TaxInfoHeaderCellClass} {
    background-color: ${GetColor.GreyScale.Grey10} !important;
    border-right: 1px solid ${GetColor.GreyScale.Grey30};
  }

  .${TaxInfoHeaderFirstCellClass} {
    border-left: 1px solid ${GetColor.GreyScale.Grey30};
  }

  .${TaxInfoHeaderRightAlignedCellClass} {
    text-align: right;

    .ag-header-cell-label {
      justify-content: flex-end;
    }
  }

  .${TaxInfoCellLeftAlignedClass} {
    text-align: left;
  }

  .${AllocationHeaderGroupCellClass} {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;

    .ag-header-group-cell {
      background-color: ${GetColor.GreyScale.Grey20};
      padding: 0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }

  .${RangeCellClass} {
    padding: 0;
    border-width: 0;
    border-right-width: 1px;
  }

  .${DisabledCellClass} {
    color: ${GetColor.GreyScale.Grey80};
  }

  .${AxisRowClass} {
    .ag-cell {
      border: none;
      overflow: visible;
    }
  }
`;
